import React, { useEffect, useState } from "react";
import { CommonHeader } from "../../components/commons";
import AllCheckInList from "../../components/MySpace/CheckInModule/AllCheckInList";
import MyCheckInList from "../../components/MySpace/CheckInModule/MyCheckInList";
import CheckInModule from "../../components/MySpace/CheckInModule";
import { connect } from "react-redux";
import { resetSingleCheckInScheduleDetails } from "../../redux/mySpace";
import { useLocation } from "react-router-dom";
import { useMenuCheck } from "../../customHooks/useMenuCheck";

interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
const tabs: TabsType[] = [
  {
    name: "All Check-Ins",
    label: "All Check-Ins",
    display: true,
  },
  {
    name: "My Check-Ins",
    label: "My Check-Ins",
    display: true,
  },
];

type AppProps = {
  history: any;
  dispatchResetSingleCheckInScheduleDetails: () => void;
};
const CheckInScheduleList = ({
  history,
  dispatchResetSingleCheckInScheduleDetails,
}: AppProps) => {
  const search = useLocation().search;
  const redirectNotificationActiveTab: any = new URLSearchParams(search).get(
    "active_tab"
  );
  const redirectActiveTab: any = history?.location?.state?.activeTab;
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [showSendCheckInRequestModal, setShowSendCheckInRequestModal] =
    useState(false);
  const [checkInId, setCheckInId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  // User Management //
  const [isMyCheckInsViewPresent, setIsMyCheckInsViewPresent] =
    useMenuCheck("");
  const [isMyCheckInsEditPresent, setIsMyCheckInsEditPresent] =
    useMenuCheck("");
  const [isManagerViewCheckInsPresent, setIsManagerViewCheckInsPresent] =
    useMenuCheck("");
  const [
    isAddCheckInsScheduleButtonPresent,
    setIsAddCheckInsScheduleButtonPresent,
  ] = useMenuCheck("");
  // User Management //

  useEffect(() => {
    setIsMyCheckInsViewPresent("My Check-Ins Schedule List", "menu");
    setIsMyCheckInsEditPresent("Check-In Schedule Update", "menu");
    setIsManagerViewCheckInsPresent(
      "Manager's view Check-Ins Schedule List",
      "menu"
    );
    setIsAddCheckInsScheduleButtonPresent(
      "Add Check-In Schedule Date and Time",
      "menu"
    );
  }, []);

  useEffect(() => {
    if (!showSendCheckInRequestModal) {
      setCheckInId("");
    }
  }, [showSendCheckInRequestModal]);

  useEffect(() => {
    if (
      redirectActiveTab === "myCheckInList" ||
      redirectNotificationActiveTab == "myCheckInList"
    ) {
      setActiveTab("My Check-Ins");
    } else {
      setActiveTab("All Check-Ins");
    }
  }, [redirectActiveTab, redirectNotificationActiveTab]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const renderTabs = () => {
    const filterTab =
      isMyCheckInsViewPresent && isManagerViewCheckInsPresent
        ? tabs
        : isMyCheckInsViewPresent
        ? [tabs[1]]
        : [tabs[0]];
    let finalTab = filterTab.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };
  const handleEditCheckInSchedule = (data: string) => {
    setShowSendCheckInRequestModal(!showSendCheckInRequestModal);
    setCheckInId(data);
    setIsEdit(true);
  };

  const handleCheckInModule = () => {
    setIsEdit(false);
    setShowSendCheckInRequestModal(!showSendCheckInRequestModal);
    setCheckInId("");
    dispatchResetSingleCheckInScheduleDetails();
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="Check-Ins" />
      </div>
      <div className="boxs mt-4">
        <div
          className="d-flex align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div className="col-md-12 p-0 ">
            <div
              className="d-flex align-items-center"
              style={{
                background: "#d8dee4",
                borderRadius: "5px 5px 0 0",
                padding: "0px 15px",
                justifyContent: "space-between",
              }}
            >
              <div className="d-flex">{renderTabs()}</div>
              {activeTab === "My Check-Ins" &&
                isAddCheckInsScheduleButtonPresent && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      handleCheckInModule()
                    }}
                  >
                    + Add Schedule
                  </button>
                )}
            </div>
          </div>
        </div>
        {activeTab === "My Check-Ins" && isMyCheckInsViewPresent && (
          <MyCheckInList
            handleEditCheckInSchedule={handleEditCheckInSchedule}
            isMyCheckInsEditPresent={isMyCheckInsEditPresent}
            showCheckInRequestModal={showSendCheckInRequestModal}
          />
        )}
        {activeTab === "All Check-Ins" && isManagerViewCheckInsPresent && (
          <AllCheckInList />
        )}
      </div>
      <CheckInModule
        history={history}
        showCheckInRequestModal={showSendCheckInRequestModal}
        type="CheckInScheduleList"
        setShowCheckInRequestModal={setShowSendCheckInRequestModal}
        checkInId={checkInId}
        isEdit={isEdit}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSingleCheckInScheduleDetails: () =>
    dispatch(resetSingleCheckInScheduleDetails()),
});

export default connect(null, mapDispatchToProps)(CheckInScheduleList);
